export default "__VITE_ASSET__DQptJTYW__"